import { render, staticRenderFns } from "./select-user.vue?vue&type=template&id=7bfa368c&scoped=true&"
import script from "./select-user.vue?vue&type=script&lang=ts&"
export * from "./select-user.vue?vue&type=script&lang=ts&"
import style0 from "./select-user.vue?vue&type=style&index=0&id=7bfa368c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfa368c",
  null
  
)

export default component.exports